<div class="row" style="margin-top: 15px">
  <page-alert
    style="padding: 15px"
    message="Pagamento presencial confirmado com sucesso!"
    *ngIf="showSuccessMessage"
    alertClass="alert-success"
  ></page-alert>
  <page-alert [message]="paymentErrorMessage" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
</div>

<div class="orientacoes-container">
  <p>Prezado(a) Paciente,</p>
  <p>Para garantir que seu exame seja realizado de forma eficiente e no horário agendado, pedimos que siga as orientações abaixo:</p>
  <p>
    <strong>Chegada Antecipada:</strong> Solicitamos que você chegue à clínica com pelo menos 10 minutos de antecedência. Esse tempo é necessário para
    realizar os procedimentos de pré-atendimento e evitar atrasos.
  </p>
  <p>
    <strong>Pagamento:</strong> É necessário que o pagamento seja efetuado antes da realização do exame. Dirija-se ao setor de atendimento ao cliente
    assim que chegar, para que possamos processar o pagamento e fornecer as instruções necessárias para o seu exame.
  </p>
</div>

<div class="checkbox-container" style="margin-top: 15px" *ngIf="userType == 'secretary'">
  <label> <input type="checkbox" [(ngModel)]="confirmPayment" /> Pagamento Recebido? </label>
</div>
<div class="checkbox-container" style="margin-top: 15px" *ngIf="canConfirmPhysicalPayment() && userType != 'secretary'">
  <label> <input type="checkbox" [(ngModel)]="confirmPayment" /> Pagamento Recebido? </label>
</div>
<button
  *ngIf="canConfirmPhysicalPayment()"
  [disabled]="!canSubmitPhysicalPayment()"
  (click)="createPayment()"
  class="button-orientacoes"
  mat-raised-button
  color="primary"
>
  {{ submitted ? 'Salvando...' : 'Confirmar recebimento' }}
</button>
<div class="patient-payment-info" *ngIf="!canConfirmPhysicalPayment()">Pagamento presencial deve ser confirmado pela secretaria no atendimento.</div>
